import { CognitoUserPool } from 'amazon-cognito-identity-js';

const poolData = {
  UserPoolId: 'us-east-1_r5nQPZJKZ',
  ClientId: '2pd01kr5c9amoohrip8rja01ml',
};

export default new CognitoUserPool(poolData);

